const isDictionary = (item) => {
    return Boolean(item && typeof item === 'object' && !Array.isArray(item));
};
export const mergeDictionaries = (target, sources, { skipEmpty = false, protectTarget = false } = {}) => {
    if (!sources.length) {
        return target;
    }
    const source = sources.shift();
    if (isDictionary(target) && isDictionary(source)) {
        for (const key in source) {
            if (isDictionary(source[key])) {
                if (!target[key]) {
                    Object.assign(target, { [key]: {} });
                }
                if (!protectTarget || typeof target[key] === typeof source[key]) {
                    mergeDictionaries(target[key], [source[key]], {
                        skipEmpty,
                        protectTarget,
                    });
                }
            }
            else {
                if (!source[key] && skipEmpty) {
                    continue;
                }
                // Prevent the structure of the target dictionary from being altered
                if (protectTarget && target[key] && typeof target[key] !== typeof source[key]) {
                    continue;
                }
                Object.assign(target, { [key]: source[key] });
            }
        }
    }
    return mergeDictionaries(target, sources, {
        skipEmpty,
        protectTarget,
    });
};
//# sourceMappingURL=mergeDictionaries.js.map